<div *ngIf="alertBannerService.isVisible" class="position-absolute w-100 h-inherit z-index-max bg-danger text-light d-flex align-items-center pl-5">
    <i class="fas fa-exclamation-triangle"></i>
    <strong class="ml-2">{{alertBannerService.title}}</strong>
    <span class="ml-4">{{alertBannerService.message}}</span>
</div>